define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/config",
	"csi/def",
	"csi/def/Field",
	"csi/enums",
	"csi/form/Widget",
	"csi/reflection",
	"csi/resolver",
	"csi/xml"
], function(array,declare,lang,csi,config,def,Field,enums,Widget,reflection,resolver,xml) {

	const LINK_STYLE_SIZE_CHART_TO_SHAPE_SIZE_CHART = "LinkStyleSizeChartToShapeSizeChart";

return declare(Widget, {
		REVISION_BEHAVIOR: "RevisionBehavior",
		SUBTYPE: "Subtype",

		_insertRevisionBehaviorField: function() {
			// summary: insert field for DataSheet copy revision behavior on Data Sheet form
			this.insertField(lang.mixin(new Field(), {
				m_label: this.REVISION_BEHAVIOR,
				m_name: this.REVISION_BEHAVIOR,
				idParameter: this.REVISION_BEHAVIOR,
				m_type: xml.ATTR_ENUM,
				m_typeControl: def.FIELD_FILTERING_SELECT
			}), 0);

			var classType = this.defView.getRootClass().getType();
			var copyBehavior = config.getClassSetting(classType,"CopyBehavior");
			this.addDefaultValue(this.REVISION_BEHAVIOR, copyBehavior);
		},

		_shouldInsertRevisionBehaviorField: function() {
			// Summary: return true if the field for DataSheet copy revision behavior should be inserted.  By default, true for Copy form if the ClassSettings CopyBehaviorLocked == false
			if(this.isCreateForm() && !this._isAggregateForm())
				return false;

			// figure out classSettingUrl
			var classType = this.defView.getRootClass().getType();
			var copyBehaviorLocked = config.getClassSetting(classType,"CopyBehaviorLocked");
			return (!copyBehaviorLocked);
		},

		_isAggregateForm: function() {
		    var fd = this.getFormData();
		    if (!fd)
		        return false;

		    var source = fd.getSource();

		    if (!source)
		        return false;

		    return source.isAggregate;
		},

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			// summary: return correct store for RevisionCopyOptions enum
			if (field.m_name == this.REVISION_BEHAVIOR)
				return enums.getStore("RevisionCopyOptions");

			return this.inherited(arguments);
		},
		_insertSubtypeField: function() {
			this.insertFieldIfNotExist(this.SUBTYPE, 1 , {
				m_typeControl: def.FIELD_FILTERING_SELECT,
			});
			this.setFieldDisabled(this.SUBTYPE, true);
		},
		
		_resolveView: function() {
			const actionId = this.defView.m_formData.m_source.m_action.m_id;
			// Insert Revision Behavior field on the copy form
			if(this._shouldInsertRevisionBehaviorField()) {
				this._insertRevisionBehaviorField();
			}
			if (actionId == "NewFromStyleSizeChart") {
				const cache = this.cacheView
				const self = this.getFormData();
				const shape = self.m_source.m_urlParent;
				const styleURL = self.m_source.m_aSources[0].__Parent__;
				const styleNode = cache.getNode(styleURL);
				const shapeOnStyle = styleNode.Shape;
			// Insert Link Style Size Chart to Shape Size Chart check box if the Style belongs to the Shape 
			// and the Style Size Chart's ownership type is owned
			if(shapeOnStyle == shape && cache.getNode(this.urlRoot).ShapeSizeChart == csi.EMPTY_URL) {
				this.insertField(lang.mixin(new Field(), {
					m_label: LINK_STYLE_SIZE_CHART_TO_SHAPE_SIZE_CHART,
					m_typeControl: def.FIELD_CHECKBOX
				}));
			}
			this._insertSubtypeField();
		}
			this.inherited(arguments);
		}
	});
});